export default "__VITE_ASSET__Df4Vs4xB__"